import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

// TODO: same headshot used on /about — upload to your asset host and point
// this at the real URL.
const founderPhoto = "https://images.checkoutdm.com/static/founder-prince-jindal.jpg";

export default function FounderStrip() {
  return (
    <section className="px-6 pt-16 pb-16 md:px-12 md:pt-20 md:pb-20">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mx-auto flex max-w-4xl flex-col items-center gap-6 rounded-[2rem] border border-ink/10 bg-white p-8 text-center shadow-sm md:flex-row md:gap-8 md:p-10 md:text-left"
      >
        <img
          src={founderPhoto}
          alt="Prince Jindal, founder of Checkout DM"
          className="h-20 w-20 flex-none rounded-2xl object-cover shadow-md md:h-24 md:w-24"
        />

        <div className="flex-1">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-hotpink">
            Built solo, not by a team
          </p>
          <p className="mt-2 text-lg leading-relaxed text-ink/80 md:text-xl">
            I'm Prince — I design, build, and run Checkout DM myself. Before
            this, I scaled HealthyCeleb.com to millions of monthly readers
            with a 20-person team, so when you email support, you're
            talking to the person who built the product.
          </p>
        </div>

        <Link
          to="/about"
          className="inline-flex flex-none items-center gap-1.5 whitespace-nowrap rounded-full border border-ink/15 px-5 py-2.5 text-sm font-semibold text-ink transition-colors hover:bg-ink/5"
        >
          My story
          <ArrowRight size={14} />
        </Link>
      </motion.div>
    </section>
  );
}
